import { useParams } from "react-router-dom";
import { useGetBusiness } from "../../../api";
import Page from "../../../Containers/Page";
import EditBusinessForm from "../../../Forms/EditBusinessForm";
import getApiStatusPage from "../../APIStatusPage";

function EditBusinessPage() {
  const { businessRef } = useParams();

  const getBusinessApi = useGetBusiness({
    businessRef,
    params: {
      fields:
        "tradingName,formattedAddress,postcode,businessType,location,logo,about,website,email,reference,CPH_Number",
    },
    refetchOnWindowFocus: false,
  });
  const business = getBusinessApi?.data?.business;

  const statusPage = getApiStatusPage({
    apis: [
      {
        api: getBusinessApi,
        type: "Business",
        dataRequired: true,
      },
    ],
  });
  if (statusPage) return statusPage;

  return (
    <Page title="Edit Business Profile">
      <EditBusinessForm
        business={business}
        isAdmin
        onSuccessLink={`/admin/businesses/${businessRef}`}
      />
    </Page>
  );
}
export default EditBusinessPage;
